import { useEffect, useState } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { sessionKey } from './api/auth';
import { setUnauthorizedHandler } from './api/client';
import { createQueryClient } from './api/queryClient';
import { ToastProvider } from './components';
import { routes } from './routes';
import { ThemeProvider } from './theme/ThemeProvider';

export function App() {
  const [queryClient] = useState(createQueryClient);
  const [router] = useState(() => createBrowserRouter(routes));

  useEffect(() => {
    // A 401 on any authenticated call means the session ended (expiry, revocation, sign-out
    // elsewhere). Drop cached data; the route guards then send the user to the right sign-in page
    // with a `next` parameter.
    setUnauthorizedHandler(() => {
      queryClient.removeQueries({ predicate: (q) => q.queryKey[0] !== 'branding' && q.queryKey[0] !== 'session' });
      queryClient.setQueryData(sessionKey, null);
    });
  }, [queryClient]);

  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <ToastProvider>
          <RouterProvider router={router} />
        </ToastProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
}
